import { NgModule } from '@angular/core';
import {Routes, RouterModule, provideRoutes} from '@angular/router';
import { LaunchComponent } from './launch.component';
import {EditComponent} from './edit.component';
import {ViewComponent} from './view.component';
import {ViewTaskComponent} from './view-task.component';
import {EditTaskComponent} from './edit-task.component';

const routes: Routes = [
  { path: 'launch', component: LaunchComponent },
  { path: 'edit', component: EditComponent },
  { path: 'view', component: ViewComponent },
  { path: 'viewtask', component: ViewTaskComponent },
  { path: 'edittask', component: EditTaskComponent },
];

@NgModule({
imports: [{
    ngModule: RouterModule,
    providers: [ provideRoutes(routes) ]
  }],
  exports: [RouterModule],
})
export class TaskRoutingModule {}
